// extracted by mini-css-extract-plugin
module.exports = {"shop":"shop--3y2qB","othertest_input":"othertest_input--18vUx","othertest_go":"othertest_go--3Y-JU"};